import {
  CardDocumentsDataProps
} from '@/components';
import { SupplyOrderProps } from '@/types';


const getFinanceDocuments = (
  t: (value: string) => string,
  supplyOrder?: SupplyOrderProps,
) => {
  const docs: { file: string; title: string }[] = []

  if (supplyOrder?.invoice?.pdfFile) {
    docs.push({
      file: supplyOrder.invoice.pdfFile,
      title:
        t('tabDocumentsInvoicePdfFile')
    })
  }

  if (supplyOrder?.invoice?.xmlFile) {
    docs.push({
      file: supplyOrder.invoice.xmlFile,
      title:
        t('tabDocumentsInvoiceXmlFile')
    })
  }

  supplyOrder?.payments?.forEach((payment, index) => {
    if (payment?.statements?.[0]?.transaction?.proofFile) {
      docs.push({
        file: payment?.statements?.[0]?.transaction?.proofFile,
        title:
          t('tabDocumentsTransactionProofFile') + ` ${index + 1}`,
      })
    }


    if (payment?.statements?.[0]?.transaction?.additionalProofFile) {
      docs.push({
        file: payment?.statements?.[0]?.transaction?.additionalProofFile,
        title:
          t('tabDocumentsTransactionAdditionalProofFile') + ` ${index + 1}`,
      })
    }
  })



  return docs
}

export const getInternalDocuments = (
  t: (value: string) => string,
  supplyOrder?: SupplyOrderProps,
): CardDocumentsDataProps[] | undefined => {
  if (!supplyOrder) return undefined

  const result: CardDocumentsDataProps[] = []

  const financeDocuments = getFinanceDocuments(t, supplyOrder)

  if (financeDocuments?.length > 0) {
    result.push({
      title: t('tabDocumentsFinanceTitle'),
      data: financeDocuments,
    })
  }

  return result
}

export const getExternalDocuments = (
  t: (value: string) => string,
  supplyOrder?: SupplyOrderProps,
) => {
  const docs: { file: string; title: string }[] = []

  if (supplyOrder?.shipmentCustomCertificateFile) {
    docs.push({
      file: supplyOrder.shipmentCustomCertificateFile,
      title:
        t('tabDocumentsExternalShipmentCustomCertificate')
    })
  }

  return docs
}